module.exports = __webpack_public_path__ + "static/media/pact-pt-cert.a9dd63c8.png";